module.exports = __webpack_public_path__ + "static/img/8.-SATA-Cable.3761995.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_images/8.-SATA-Cable.jpg
// module id = 8t8k
// module chunks = 1